import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-746c833b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lesson-lab__info" }
const _hoisted_2 = { class: "lesson-lab__icon" }
const _hoisted_3 = { class: "lesson-lab__text" }
const _hoisted_4 = { class: "lesson-lab__tags" }
const _hoisted_5 = {
  key: 1,
  class: "lp-tag lp-tag--grey"
}

import { computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { Actions } from '@/store/enums/StoreEnums';
import HcIcon from '@/modern/components/ui/HcIcon.vue';
import LabEnvironment from '@/modern/components/training/learningPaths/item/LabEnvironment.vue';
import { LEVEL_TONES, labLevel } from '@/modern/components/training/learningPaths/item/labs';
import { useCourseI18n } from '../course';


export default /*#__PURE__*/_defineComponent({
  props: {
    challenge: null
  },
  emits: ["flag-accepted"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'flag-accepted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  // Desafio como vem dentro da aula; a versão completa (instância, progresso) vem do store
  challenge: any
}





const store = useStore();
const { t, lang, tc } = useCourseI18n();

const stored = computed(() => store.getters.getChallenges);
const resource = computed(() =>
  stored.value && String(stored.value.id) === String(props.challenge.id) ? stored.value : props.challenge
);

const level = computed(() => labLevel(resource.value));
const percentage = computed(() => Number(resource.value.percentage) || 0);
const totalFlags = computed(() => Number(resource.value.total_flags) || 0);
const flagsDone = computed(() => Math.round((percentage.value / 100) * totalFlags.value));
const solved = computed(() => percentage.value >= 100 || Boolean(resource.value.is_solved));

const load = () => store.dispatch(Actions.GET_CHALLENGE, props.challenge.id).catch(() => undefined);
onMounted(load);
watch(() => props.challenge.id, load);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LabEnvironment, {
    key: _unref(resource).id,
    kind: "challenge",
    resource: _unref(resource),
    compact: "",
    class: _normalizeClass(["lesson-lab", { 'lesson-lab--solved': _unref(solved) }]),
    onFlagAccepted: _cache[0] || (_cache[0] = ($event: any) => (emit('flag-accepted')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(HcIcon, {
            name: _unref(solved) ? 'check' : 'terminal',
            size: 22
          }, null, 8, ["name"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("small", null, _toDisplayString(_unref(tc)('lesson_challenge')), 1),
          _createElementVNode("strong", null, _toDisplayString(_unref(resource).name), 1),
          _createElementVNode("div", _hoisted_4, [
            (_unref(level))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["lp-tag", `lp-tag--${_unref(LEVEL_TONES)[_unref(level)]}`])
                }, _toDisplayString(_unref(t)(`${_unref(lang)}.common.${_unref(level)}`)), 3))
              : _createCommentVNode("", true),
            (_unref(resource).points)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createVNode(HcIcon, {
                    name: "gem",
                    size: 13
                  }),
                  _createTextVNode(_toDisplayString(_unref(resource).points) + " xp", 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(totalFlags))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  class: _normalizeClass(["lp-tag", _unref(solved) ? 'lp-tag--green' : 'lp-tag--grey'])
                }, [
                  _createVNode(HcIcon, {
                    name: "flag",
                    size: 13
                  }),
                  _createTextVNode(_toDisplayString(_unref(flagsDone)) + "/" + _toDisplayString(_unref(totalFlags)) + " flags ", 1)
                ], 2))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["resource", "class"]))
}
}

})